import { Print, PictureAsPdf } from "@mui/icons-material";
import { Backdrop, Box, Button, IconButton, Modal, Typography } from "@mui/material";
import Carousel from "react-material-ui-carousel";
import { Helper } from "../../utils/Helpers";
import { useEffect, useState } from "react";
import { isPdfUrl } from "../../utils/isPdfUrl";
const { printImage } = new Helper();

const ViewImageModal = ({
  index = 0,
  isOpen,
  handleClose,
  images = [],
  isPrint,
}) => {
  const [currentIndex, setCurrentIndex] = useState(index);

  useEffect(() => {
    setCurrentIndex(index);
  }, [index]);

  const handleImageChange = (newIndex) => {
    setCurrentIndex(newIndex);
  };

  const isCurrentPdf = isPdfUrl(images[currentIndex]);

  return (
    <Modal
      open={isOpen}
      slots={{ backdrop: Backdrop }}
      onClose={handleClose}
      closeAfterTransition
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 30,
            backgroundColor: "white",
            borderRadius: "50%",
            boxShadow: "0px 0px 5px rgba(0,0,0,0.3)",
            cursor: "pointer",
            display: isPrint && !isCurrentPdf ? "flex" : "none",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              printImage(images[currentIndex].url);
            }}
          >
            <Print fontSize="small" />
          </IconButton>
        </Box>

        <Carousel
          sx={{
            width: { xs: "88vw", sm: "500px" },
            height: { xs: "70vw", sm: "500px" },
            borderRadius: "10px",
            backgroundColor: "#FFFFFF",
            alignItems: "center",
            justifyContent: "center",
          }}
          autoPlay={false}
          swipe={images.length > 1}
          navButtonsAlwaysInvisible={images.length === 1}
          indicators={false}
          index={currentIndex}
          onChange={handleImageChange}
        >
          {images?.map((val, imageIndex) => (
            <Box
              key={imageIndex}
              sx={{
                height: { xs: "70vw", sm: "500px" },
                width: { xs: "88vw", sm: "500px" },
              }}
            >
              {isPdfUrl(val) ? (
                <Box
                  sx={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                    borderRadius: "10px",
                    boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.5)",
                  }}
                >
                  <PictureAsPdf sx={{ fontSize: 100, color: "#ef4444" }} />
                  <Typography
                    variant="body2"
                    sx={{
                      maxWidth: "80%",
                      textAlign: "center",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {val.key?.split("-").pop() || "document.pdf"}
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={() => window.open(val.url, "_blank")}
                    sx={{
                      backgroundColor: "#f59e0b",
                      "&:hover": { backgroundColor: "#d97706" },
                    }}
                  >
                    Open PDF in new tab
                  </Button>
                </Box>
              ) : (
                <img
                  height="100%"
                  width="100%"
                  src={val.url}
                  style={{
                    borderRadius: "10px",
                    boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.5)",
                  }}
                />
              )}
            </Box>
          ))}
        </Carousel>
      </Box>
    </Modal>
  );
};

export default ViewImageModal;
